/* eslint-disable react/forbid-prop-types */
import React from 'react'
import { any } from 'prop-types'
import { Route } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'
import { usePermission } from '@fs/zion-permissions'
import LoadingSpinner from '../shared/components/LoadingSpinner'

export default function AiEffortsPermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  const { signedIn, userLoading } = useUser()

  const [hasContentReviewPermission, contentReviewStatus] = usePermission(
    'DiscoveryContentReviewPermission',
    'DiscoveryManageContentContext'
  )
  const [hasDatabaseAdminPermission, databaseAdminStatus] = usePermission(
    'DiscoveryDatabasePermission',
    'DiscoveryAdminDatabaseContext'
  )
  const [hasAdminUiPermission, adminUiStatus] = usePermission('DiscoveryAdminUIPermission', 'DiscoveryAdminUIContext')
  const [hasAssetPermission, assetStatus] = usePermission('DiscoveryAssetPermission', 'DiscoveryAdminAssetContext')

  // usePermission starts out [false, 'loading'], so rendering off the boolean alone flashes the
  // Unauthorized fallback for permitted users. Wait for every check to settle first.
  const permissionsLoading = [contentReviewStatus, databaseAdminStatus, adminUiStatus, assetStatus].includes('loading')
  const hasPermission = Boolean(
    hasContentReviewPermission || hasDatabaseAdminPermission || hasAdminUiPermission || hasAssetPermission
  )
  const loading = userLoading || permissionsLoading

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => (
        <>
          {loading && <LoadingSpinner size="lg" />}
          {!loading && signedIn && hasPermission && <Component {...props} />}
          {!loading && (!signedIn || !hasPermission) && <Fallback {...props} />}
        </>
      )}
      requirePersonalData={requirePersonalData}
    >
      {children}
    </Route>
  )
}

AiEffortsPermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
  path: any,
  exact: any,
  requirePersonalData: any,
}
